/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
    ScheduledRequest,
    ScheduledRequestFromJSON,
    ScheduledRequestFromJSONTyped,
    ScheduledRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface ScheduledRequestsListResponse
 */
export interface ScheduledRequestsListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof ScheduledRequestsListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<ScheduledRequest>}
     * @memberof ScheduledRequestsListResponse
     */
    entries: Array<ScheduledRequest>;
}

export function ScheduledRequestsListResponseFromJSON(json: any): ScheduledRequestsListResponse {
    return ScheduledRequestsListResponseFromJSONTyped(json, false);
}

export function ScheduledRequestsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledRequestsListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(ScheduledRequestFromJSON)),
    };
}

export function ScheduledRequestsListResponseToJSON(value?: ScheduledRequestsListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(ScheduledRequestToJSON)),
    };
}


